import { isPlugin } from "state/app";

export const bildebankenModeName = getBildebankenModeName();

function getBildebankenModeName(): string {
  if (isPlugin) return "plugin";
  else return "standalone";
}
